import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';

import vw from 'src/styles/utils';

function SelectView(props) {
  const { label, gridArea, floorplans, required, ref, id, disabled, selectedPlan, ...rests } = props;
  const [views, setViews] = useState(null);

  useEffect(() => {
    sortUniqueView();
  }, [floorplans, selectedPlan])

  const sortUniqueView = () => {
    let views = [], plans;

    if (selectedPlan==='any floorplan') {
      floorplans && floorplans.forEach(floorplan => {
        floorplan.others.forEach(other => {
          views = [...views, other.view]; 
        })
      });
    } else {
      plans = floorplans?.filter(floorplan => floorplan.plan===selectedPlan);

      plans && plans.forEach(plan => {
        plan.others.forEach(other => {
         
          views = [...views, other.view];
         
        })
      });
    }
    
    

    views.sort();

    setViews([...new Set(views)]);
  }

  return (
    <Root gridArea={gridArea} ref={ref} {...rests}>
      <label htmlFor={id}>{label}</label>
      <select required={required} id={id} name={id} disabled={disabled} defaultValue="--">
        <option value="--" disabled>--</option>
        {
          views && views.length > 1 &&
                  <option value="any view">Any View</option>
          }
    
          
       
       
        {
          views && views.length >= 1 && views.map( view => (
            <option value={view} key={view}>{view}</option>
          ))
        }
      </select>
    </Root>
  )
}

SelectView.propTypes = {
  label: PropTypes.string,
  floorplans: PropTypes.array,
  gridArea: PropTypes.string,
  required: PropTypes.bool,
  id: PropTypes.string,
  ref: PropTypes.oneOfType([
    PropTypes.func,
    PropTypes.shape({ current: PropTypes.instanceOf(Element) })
  ]),
}

const Root = styled.div`
  display: flex;
  flex-direction: column;
  grid-area: ${props => props.gridArea};

  label {
    font-family: Gotham Book;
    font-style: normal;
    font-weight: normal;
    color: #000000;
    text-align: left;
    ${vw('font-size', 14, 12)}
    ${vw('line-height', 17, 19)}
    ${vw('letter-spacing', 0.06)}
    ${vw('margin-bottom', 5, 3)}
  }
  
  select {
    border: 1px solid #E1E1E1;
    box-sizing: border-box;
    color: #747474;
    ${vw('height', 30)}
    ${vw('font-size', 8, 12)}
    ${vw('line-height', 10, 16)}
    ${vw('letter-spacing', 0.06)}
    ${vw('padding-left', 3, 5)}
  }
  select:disabled {
    opacity: .5;
    background: #E1E1E1;
  }
`;

export default SelectView

